// export action types
import { UPDATE_APP_CONTEXT } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @param {object} payload - payload object (data to dispatch)
 * @desc Returns action object for **TYPE_SOME_EVENT** event
 * @returns {object} - Redux action object
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { updateAppContext } from 'actions/updateAppContext';
 *
 * // dispatch action
 * store.dispatch( updateAppContext( payload ) );
 */
export const updateAppContext = ( payload ) => {
    return {
        type: UPDATE_APP_CONTEXT,
        payload: payload
    };
};
